export const defaultFeedbackMessage = {
  defaultAllCorrectFeedbackMessageResId: 'Congratulations, you got it!',
  defaultAllWrongFeedbackMessageResId: "That's not the answer!",
  defaultPartialCorrectFeedbackMessageResId:
    'Well done, you are partially correct.'
};
